import {
  companyProfileCollectionImageConfigurations,
  companyProfileImageConfigurations,
  companyProfileLogoImageConfigurations,
  companyProfileMobileImageConfigurations,
} from './imageConfigurations';

const profileBySlugVariables = (slug: string) => ({
  slug,
  imageConfigurations: companyProfileImageConfigurations,
  mobileImageConfigurations: companyProfileMobileImageConfigurations,
  logoConfigurations: companyProfileLogoImageConfigurations,
  collectionImageConfigurations:
    companyProfileCollectionImageConfigurations,
});

export default profileBySlugVariables;
